import { render } from "./description_modal.vue?vue&type=template&id=0a8bf786"
import script from "./description_modal.vue?vue&type=script&lang=js"
export * from "./description_modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__